// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ThemeSelection__title-d80beb {
  color: var(--base-70);
  font: var(--font-button);
  letter-spacing: var(--font-spacing-button);
  padding: 16px 24px 0;
}

.ThemeSelection__items-ddd444 {
  padding: 0 24px 16px;
}

.ThemeSelection__label-a6b7f8 {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/AppearanceSettingsPopup/ThemeSelection/ThemeSelection.styles.m.css"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,wBAAA;EACA,0CAAA;EACA,oBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;AACF","sourcesContent":[".title {\n  color: var(--base-70);\n  font: var(--font-button);\n  letter-spacing: var(--font-spacing-button);\n  padding: 16px 24px 0;\n}\n\n.items {\n  padding: 0 24px 16px;\n}\n\n.label {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `ThemeSelection__title-d80beb`,
	"items": `ThemeSelection__items-ddd444`,
	"label": `ThemeSelection__label-a6b7f8`
};
module.exports = ___CSS_LOADER_EXPORT___;
